import styled from "styled-components";

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px 24px;
  border-bottom: 1px solid;

  @media (min-width: 500px) {
    flex-direction: row;
    justify-content: space-between;
    padding: 20px 40px;
  }
`;
